function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import hexToRgba from "hex-to-rgba";
import { memo, useEffect, useRef, useState } from "react";
import { Animated, Easing, Platform, Pressable } from "react-native";
import { v4 as uuid } from "uuid";
import { Icon } from "./Icon";
import { Text, ThemeText } from "./Text";
import { View } from "./View";
import { useIsSafeLayoutAnimating } from "../hooks/useSafeLayoutAnimation";
import { useTheme } from "../styles";
// CheckboxInner is purely a perf optimization. onChangeValue is often the
// prop that changes but only affects the TouchableWithoutFeedback wrapper component
// If that changes, we dont care about rerendering the visible portion of the component
var CheckboxInner = /*#__PURE__*/ memo(function CheckboxInner(param) {
    var ariaLabel = param['aria-label'], error = param.error, horizontal = param.horizontal, label = param.label, labelWeight = param.labelWeight, labelFont = param.labelFont, tmp = param.size, _size = tmp === void 0 ? 'large' : tmp, testID = param.testID, value = param.value, variant = param.variant;
    var isAnimating = useIsSafeLayoutAnimating();
    var theme = useTheme().theme;
    var animValue = useRef(new Animated.Value(value ? 1 : 0));
    useEffect(function() {
        Animated.timing(animValue.current, {
            useNativeDriver: Platform.OS !== 'web',
            toValue: value ? 1 : 0,
            duration: 150,
            easing: Easing.inOut(Easing.linear)
        }).start();
    }, [
        animValue,
        value
    ]);
    var fontTheme = theme.typography[labelFont !== null && labelFont !== void 0 ? labelFont : theme.checkbox.optionLabel];
    var size = _size === 'small' ? theme.checkbox.sizeSmall : theme.checkbox.size;
    var _ref;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            label ? /*#__PURE__*/ _jsx(ThemeText, {
                text: label,
                // https://github.com/necolas/react-native-web/blob/a5ba27c6226aa182979a9cff8cc23c0f5caa4d88/packages/react-native-web/src/modules/AccessibilityUtil/propsToAccessibilityComponent.js#L40
                role: Platform.OS === 'web' ? 'label' : undefined,
                "aria-label": ariaLabel,
                testID: testID,
                style: {
                    flex: horizontal ? 1 : 0,
                    marginBottom: horizontal ? 0 : 4,
                    marginLeft: horizontal ? theme.checkbox.optionLabelSpacing : 0
                },
                fontTheme: fontTheme,
                weight: (_ref = labelWeight !== null && labelWeight !== void 0 ? labelWeight : fontTheme.weight) !== null && _ref !== void 0 ? _ref : 'semibold'
            }) : null,
            /*#__PURE__*/ _jsx(View, {
                style: {
                    height: Math.max(fontTheme.lineHeight, size),
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ _jsx(View, {
                    style: [
                        {
                            alignItems: 'center',
                            borderColor: theme.color.primary100,
                            borderRadius: variant === 'radio' ? 15 : 4,
                            borderWidth: 2,
                            height: size,
                            justifyContent: 'center',
                            overflow: variant === 'radio' ? 'hidden' : undefined,
                            width: size
                        }
                    ],
                    children: /*#__PURE__*/ _jsx(Animated.View, {
                        style: {
                            alignItems: 'center',
                            backgroundColor: hexToRgba(theme.color.primary100),
                            height: size - 3,
                            justifyContent: 'center',
                            opacity: isAnimating ? value ? 1 : 0 : animValue.current,
                            width: size - 3
                        },
                        // @ts-expect-error
                        dataSet: {
                            noselect: ''
                        },
                        children: variant === 'radio' ? /*#__PURE__*/ _jsx(View, {
                            style: {
                                backgroundColor: 'transparent',
                                borderColor: 'white',
                                borderWidth: 3,
                                height: size - 2,
                                width: size - 2,
                                borderRadius: 13
                            }
                        }) : /*#__PURE__*/ _jsx(Animated.View, {
                            style: {
                                transform: [
                                    {
                                        scale: isAnimating ? value ? 1 : 0 : animValue.current
                                    }
                                ]
                            },
                            children: /*#__PURE__*/ _jsx(Icon, {
                                name: "check",
                                size: size - 10,
                                color: "white"
                            })
                        })
                    })
                }, isAnimating.toString())
            })
        ]
    });
});
/**
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-74}
 */ export function Checkbox(_param) {
    var onChangeValue = _param.onChangeValue, testID = _param.testID, error = _param.error, props = _object_without_properties(_param, [
        "onChangeValue",
        "testID",
        "error"
    ]);
    var theme = useTheme().theme;
    var _useState = _sliced_to_array(useState(uuid()), 1), defaultTestID = _useState[0];
    testID = testID || defaultTestID;
    var size = props.size === 'small' ? theme.checkbox.sizeSmall : theme.checkbox.size;
    return /*#__PURE__*/ _jsxs(Pressable, {
        testID: testID,
        disabled: props.disabled,
        onPress: function(e) {
            if (Platform.OS === 'web') {
                e.preventDefault();
            }
            onChangeValue(!props.value);
        },
        hitSlop: {
            top: 8,
            left: 8,
            bottom: 8,
            right: 8
        },
        role: props.variant === 'radio' ? 'radio' : 'checkbox',
        "aria-disabled": props.disabled,
        "aria-checked": props.value,
        "aria-labelledby": testID ? "".concat(testID, "_label") : undefined,
        children: [
            /*#__PURE__*/ _jsx(View, {
                row: props.horizontal,
                style: [
                    props.horizontal ? {
                        flexDirection: 'row-reverse',
                        alignItems: 'flex-start'
                    } : null,
                    props.disabled ? {
                        opacity: 0.5
                    } : null
                ],
                children: /*#__PURE__*/ _jsx(CheckboxInner, _object_spread_props(_object_spread({}, props), {
                    testID: testID ? "".concat(testID, "_label") : undefined
                }))
            }),
            error ? /*#__PURE__*/ _jsx(Text, {
                text: error,
                style: {
                    marginLeft: props.horizontal ? size + theme.checkbox.optionLabelSpacing : 0,
                    marginTop: 5
                },
                color: theme.color.danger,
                size: 13,
                testID: "".concat(testID, "_error")
            }) : null
        ]
    });
}
